// ProudlyCaringSeniorsSection.js
import React from 'react';

const ProudlyCaringSeniorsSection = () => {
  return (
    <section className="bg-bnCream py-16 md:py-24">
      <div className="max-w-4xl mx-auto px-6 md:px-12 text-center">
        <p className="text-bnAccent text-xs md:text-sm font-medium tracking-[0.22em] uppercase mb-5">
          B & N Enterprise Home Care
        </p>
        <h2 className="font-display font-light text-bnInk leading-[1.1] text-3xl md:text-4xl lg:text-5xl mb-6">
          Proudly Caring for Canberra's Seniors, One Home at a Time
        </h2>
        <p className="text-bnBody text-base md:text-lg leading-relaxed max-w-2xl mx-auto">
          At B & N Enterprise, we believe every older person deserves to feel valued, respected, and supported in the place they call home. Our carers provide personalised support that encourages safety, independence, and companionship, helping families across Canberra find peace of mind while their loved ones live life to the fullest.
        </p>
      </div>
    </section>
  );
};

export default ProudlyCaringSeniorsSection;
